<script setup>
// NOTICE: KAPTION-INTEGRATION
// Simple div-based toggle switch component (no checkbox)

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const handleClick = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<template>
  <div class="toggle-switch" @click.stop="handleClick">
    <div class="toggle-track" :class="{ active: modelValue }">
      <div class="toggle-thumb" />
    </div>
  </div>
</template>

<style scoped>
.toggle-switch {
  cursor: pointer;
  display: inline-block;
  user-select: none;
}

.toggle-track {
  width: 44px;
  height: 24px;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  transition: background 0.2s ease;
}

.toggle-track.active {
  background: #4caf50;
}

.toggle-thumb {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-track.active .toggle-thumb {
  transform: translateX(20px);
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .toggle-track {
    background: #555;
  }

  .toggle-track.active {
    background: #4caf50;
  }
}
</style>
